import { SVGProps } from "react";

const CloseButtonIcon = ({ className = "", ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={`rounded-full ${className}`}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M20.4887 20.4889C25.1767 15.8009 25.1767 8.20028 20.4887 3.51234C15.8008 -1.1756 8.20013 -1.17559 3.51219 3.51234C-1.17575 8.20028 -1.17575 15.8009 3.51219 20.4889C8.20013 25.1768 15.8008 25.1768 20.4887 20.4889Z"
        fill="#FE2415"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6552 17.3523L7.16937 8.86646C6.70201 8.39919 6.70201 7.63682 7.16937 7.16946C7.63673 6.7021 8.39919 6.70201 8.86646 7.16937L17.3523 15.6552C17.8196 16.1225 17.8196 16.8848 17.3523 17.3522C16.8849 17.8195 16.1225 17.8196 15.6552 17.3523Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.16937 15.6552L15.6552 7.16937C16.1225 6.70201 16.8848 6.70201 17.3522 7.16937C17.8195 7.63673 17.8196 8.39919 17.3523 8.86646L8.86646 17.3523C8.39919 17.8196 7.63682 17.8196 7.16946 17.3523C6.7021 16.8849 6.70201 16.1225 7.16937 15.6552Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CloseButtonIcon;
